import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { fs, authentication } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { LocalizationContext } from '../localization/LocalizationContext';
import { getUserCardNumber, getUserFullName } from '../utils/userUtils';
import AuthModal from '../components/AuthModal';
import LoyaltyQrCard from '../components/LoyaltyQrCard';
import Bar from '../elements/bar';
import '../css/loyaltyQr.css';

function LoyaltyQrPage({ handleXBarItemChange }) {
  const { translations } = useContext(LocalizationContext);
  const loc = translations.loyaltyQr || {};

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem('LOGstatus') === 'true');
  const [cardNumber, setCardNumber] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authentication, async (user) => {
      if (!user) {
        setLoggedIn(false);
        setLoading(false);
        return;
      }

      setLoggedIn(true);
      try {
        const snap = await getDoc(doc(fs, 'users', user.uid));
        if (snap.exists()) {
          const userData = snap.data();
          setCardNumber(getUserCardNumber(userData) || '');
          setName(getUserFullName(userData) || user.displayName || '');
        }
      } catch (error) {
        console.error('Error loading loyalty card:', error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const onBar = handleXBarItemChange || (() => {});

  return (
    <>
      <Bar onNavClick={onBar} activeItem={3} />

      {!loggedIn && (
        <div className="fd-profile-auth-wrapper">
          <AuthModal isOpen={true} onClose={() => navigate('/')} onAuthSuccess={() => window.location.reload()} />
        </div>
      )}

      {loggedIn && (
        <div className="loyalty-qr-page">
          <div className="loyalty-qr-shell">
            <h1 className="loyalty-qr-title">{loc.title || 'My Loyalty Code'}</h1>
            <p className="loyalty-qr-subtitle">{loc.subtitle || 'Show this code to staff to earn or spend points'}</p>

            {loading ? (
              <div className="loyalty-qr-loading">{loc.loading || 'Loading your card...'}</div>
            ) : cardNumber ? (
              <LoyaltyQrCard cardNumber={cardNumber} name={name} />
            ) : (
              <div className="loyalty-qr-empty">
                <p>{loc.notAvailable || 'Loyalty card not available. Please complete your profile.'}</p>
                <button className="loyalty-qr-cta" onClick={() => navigate('/onboarding')}>
                  {loc.completeProfile || 'Complete Profile'}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default LoyaltyQrPage;
